import { useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';

interface Props {
  onSignOut: () => void;
}

export default function AccountCogMenu({ onSignOut }: Props) {
  const location = useLocation();
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const open = Boolean(anchor);

  const close = () => setAnchor(null);

  const handleSignOut = () => {
    close();
    onSignOut();
  };

  return (
    <>
      <IconButton
        color="inherit"
        aria-label="Account menu"
        aria-controls={open ? 'account-cog-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={(e) => setAnchor(e.currentTarget)}
        sx={{
          bgcolor: 'rgba(0,200,83,0.15)',
          '&:hover': { bgcolor: 'rgba(0,200,83,0.3)' },
        }}
      >
        <SettingsOutlinedIcon />
      </IconButton>
      <Menu
        id="account-cog-menu"
        anchorEl={anchor}
        open={open}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            sx: { minWidth: 200, mt: 0.5 },
          },
        }}
      >
        <MenuItem
          component={RouterLink}
          to="/my-account"
          selected={location.pathname === '/my-account'}
          onClick={close}
        >
          <ListItemIcon>
            <PersonOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>My account</ListItemText>
        </MenuItem>
        <MenuItem
          component={RouterLink}
          to="/my-bookings"
          selected={location.pathname === '/my-bookings'}
          onClick={close}
        >
          <ListItemIcon>
            <ListAltOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>My bookings</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleSignOut}>
          <ListItemIcon>
            <LogoutOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Sign out</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
